import getTheme from "./getTheme";
export default function font(font, theme) {
    return getTheme(theme).fontFamily[font];
}
//# sourceMappingURL=font.js.map